import React, { FC } from "react";
import { Unit as UnitType } from "../types";

const Unit: FC<{ unit: UnitType }> = ({ unit }) => <>{` per ${unit[0]}`}</>;

export default Unit;
